// 각성 중 BGM 덕킹 곡선(AV-SPEC: -8dB, 900ms). 순수 함수.
// 각성이 시작되면 120ms에 걸쳐 -8dB까지 내리고, 각성이 끝나면 900ms에 걸쳐 원래대로 돌린다.

export const DUCK_DB = -8;
export const DUCK_ATTACK = 0.12;
export const DUCK_RELEASE = 0.9;

/**
 * sinceStart: 각성 시작 후 초(시작 전이면 음수 또는 Infinity로 무시).
 * sinceEnd: 각성 종료 후 초. 아직 각성 중이면 음수.
 * 반환: BGM 감쇠(dB, 0 또는 음수).
 */
export function duckDb(sinceStart: number, sinceEnd: number): number {
  if (!(sinceStart >= 0) || !Number.isFinite(sinceStart)) return 0;
  // +0: -0을 0으로 맞춘다
  const attackAt = (t: number): number => (t >= DUCK_ATTACK ? DUCK_DB : (DUCK_DB * t) / DUCK_ATTACK + 0);
  if (sinceEnd < 0) return attackAt(sinceStart);
  // 종료 시점에 도달해 있던 감쇠에서 출발해 900ms에 0으로
  const from = attackAt(Math.max(0, sinceStart - sinceEnd));
  if (sinceEnd >= DUCK_RELEASE) return 0;
  return from * (1 - sinceEnd / DUCK_RELEASE) + 0;
}

export function dbToGain(db: number): number {
  return Math.pow(10, db / 20);
}
